import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SharedDataService } from './../../../../service/shared-data.service';

@Component({
  selector: 'app-ad-login-provider',
  templateUrl: './ad-login-provider.component.html',
  styleUrls: ['./ad-login-provider.component.scss'],
})
export class AdLoginProviderComponent implements OnInit {
  @Input() providers: any;
  AD_providers: any;

  constructor(private _dataService: SharedDataService) {}

  ngOnInit(): void {
    this._dataService._getRequestId().subscribe((res) => {
      this.AD_providers = this._getADprovidersURL(this.providers, res);
    });
  }

  // fetch AD providers
  _getADprovidersURL = (data: any, reqId: string) => {
    if (data) {
      return data.map((x) => {
        x['url'] = this._generateADurl(x.provider_name, reqId);
        return x;
      });
    }
    return null;
  };

  // generate AD url
  _generateADurl = (P_name: string, reqId: string) => {
    return environment.base_url + '/ad-srv/ad/login/' + P_name + '/' + reqId;
  };
}
